import React from "react";
import VersionedLegalDocument from "./VersionedLegalDocument";

export default function PersonalDataConsent() {
  return <VersionedLegalDocument documentType="ru_pd_consent" />;
}
